import React, {useState, useEffect, useMemo, useRef} from 'react';
//import {Text} from '../../components/formComponents/Inputs';
import {Select} from '../../components/formComponents/Inputs';
import Checkbox from '@mui/material/Checkbox';
import B2BApiService from "../../B2bApiService";
import * as Constants from "../../constants";
import { t } from "../../content";
import { useLocale } from '../../locale';


export default function DefineRoles() {
    const { locale } = useLocale();
    const [selectedRole, setSelectedRole] = useState("")
    const [, setSelectedRoleId] = useState(null)
    const [jobRoles, setJobRoles] = useState([]); // State variable for job roles
    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);
    //const [inputRole, setInputRole] = useState("")
    const [initialRolesForm, setInitialRolesForm] = useState({});
    const lastConfigRef = useRef(null);

    const roleConfigFormMapping = (config) => {
        return {
            [t('iam.permissions.userManagement')]: [
                {
                    title: t('iam.permissions.superUsers'),
                    items: [
                        {id: "viewAdmins", title: t('iam.permissions.viewAll'), isChecked: config.admin_permissions?.view_all},
                        {id: "createAdmin", title: t('iam.permissions.create'), isChecked: config.admin_permissions?.create},
                        {id: "editAdmin", title: t('iam.permissions.edit'), isChecked: config.admin_permissions?.edit},
                        // {id: "suspendAdmin", title: "Suspend Access", isChecked: config.admin_permissions?.suspend_access},
                        {id: "deleteAdmin", title: t('iam.permissions.delete'), isChecked: config.admin_permissions?.delete},
                    ],
                },
                {
                    title: t('iam.permissions.users'),
                    items: [
                        {id: "viewUsers", title: t('iam.permissions.viewAll'), isChecked: config.user_permissions?.view_all},
                        {id: "viewAssignedOnly", title: t('iam.permissions.viewOnlyAssigned'), isChecked: config.user_permissions?.view_assigned_only},
                        {id: "createUser", title: t('iam.permissions.create'), isChecked: config.user_permissions?.create},
                        {id: "editUser", title: t('iam.permissions.edit'), isChecked: config.user_permissions?.edit},
                        // {id: "suspendUser", title: "Suspend Access", isChecked: config.user_permissions?.suspend_access},
                        {id: "deleteUser", title: t('iam.permissions.delete'), isChecked: config.user_permissions?.delete},
                    ],
                },
                {
                    title: t('iam.permissions.roles'),
                    items: [
                        {id: "assignHRDRole", title: t('iam.permissions.assignHrdRole'), isChecked: config.role_permissions?.can_assign_hrd_role},
                        // {id: "assignManagerRole", title: "Assign HR Manager Role", isChecked: config.role_permissions?.can_assign_manager_role},
                        {id: "assignTeamLeadRole", title: t('iam.permissions.assignTeamLeadRole'), isChecked: config.role_permissions?.can_assign_teamlead_role},
                        {id: "assignSpecialistRole", title: t('iam.permissions.assignSpecialistRole'), isChecked: config.role_permissions?.can_assign_specialist_role},
                    ],
                }
            ],
            [t('nav.groups.teamManagement')]: [
                {
                    title: t('nav.items.teams'),
                    items: [
                        {id: "viewTeams", title: t('iam.permissions.viewAll'), isChecked: config.team_permissions?.view_all},
                        {id: "viewAssignedTeamsOnly", title: t('iam.permissions.viewOnlyAssigned'), isChecked: config.team_permissions?.view_assigned_only},
                        {id: "createTeams", title: t('iam.permissions.create'), isChecked: config.team_permissions?.create},
                        {id: "editTeams", title: t('iam.permissions.edit'), isChecked: config.team_permissions?.edit},
                        {id: "deleteTeams", title: t('iam.permissions.delete'), isChecked: config.team_permissions?.delete},
                        {id: "assignTeams", title: t('iam.permissions.assignTeamsToLeads'), isChecked: config.team_permissions?.can_assign},]
                },
                {
                    title: t('iam.permissions.teamMembers'),
                    items: [
                        {id: "viewMemberDetails", title: t('iam.permissions.viewDetails'), isChecked: config.team_members_permissions?.view_details},
                        {id: "addMemberToTeam", title: t('iam.permissions.inviteToTeam'), isChecked: config.team_members_permissions?.add_to_team},
                        {id: "editMemberDetails", title: t('iam.permissions.editTrailing'), isChecked: config.team_members_permissions?.edit},
                        {id: "removeMemberFromTeam", title: t('iam.permissions.removeFromTeam'), isChecked: config.team_members_permissions?.remove_from_team},
                    ]
                }
            ],
            [t('nav.groups.recruitment')]: [
                {
                    title: t('iam.permissions.talentPools'),
                    items: [
                        {id: "viewPools", title: t('iam.permissions.viewAll'), isChecked: config.pool_permissions?.view_all},
                        {id: "viewAssignedPoolsOnly", title: t('iam.permissions.viewOnlyAssigned'), isChecked: config.pool_permissions?.view_assigned_only},
                        {id: "createPools", title: t('iam.permissions.create'), isChecked: config.pool_permissions?.create},
                        {id: "editPools", title: t('iam.permissions.edit'), isChecked: config.pool_permissions?.edit},
                        {id: "deletePools", title: t('iam.permissions.delete'), isChecked: config.pool_permissions?.delete},
                        {id: "assignPools", title: t('iam.permissions.assignPoolsToLeads'), isChecked: config.pool_permissions?.can_assign},
                    ]
                },
                {
                    title: t('iam.permissions.poolMembers'),
                    items: [
                        {id: "viewDetails", title: t('iam.permissions.viewDetails'), isChecked: config.pool_members_permissions?.view_details},
                        {id: "addMemberToPool", title: t('talents.actions.inviteToPool'), isChecked: config.pool_members_permissions?.add_to_pool},
                        {id: "editMemberDetails", title: t('iam.permissions.editTrailing'), isChecked: config.pool_members_permissions?.edit},
                        {id: "removeMemberFromPool", title: t('talents.actions.removeFromPool'), isChecked: config.pool_members_permissions?.remove},
                        {id: "moveMemberFromPoolToTeam", title: t('iam.permissions.moveMemberPoolToTeam'), isChecked: config.pool_members_permissions?.move_to_team},
                    ]
                },
            ],
            [t('nav.groups.analyticsAlias')]: [
                {
                    title: t('iam.permissions.viewAnalytics'),
                    items: [
                        {id: "viewTeamAnalytics", title: t('nav.items.teams'), isChecked: config.analytics_permissions?.team_analytics, },
                        {id: "viewPositionsAnalytics", title: t('iam.permissions.talentPools'), isChecked: config.analytics_permissions?.pool_analytics}
                    ]
                }
            ],
        }
    }

    const handleSelectRole = (e) => {
        const selected = jobRoles.find(
            (item) => String(item.id) === String(e.target.value) || item.title === e.target.value
        );
        if (!selected) {
            return;
        }
        setSelectedRoleId(selected.id);
        setSelectedRole(selected.id);
        if (selected.id === 0) {
            return selected.id;
        }
        b2bServiceObj.GetRoleConfigById(selected.id, (apiData) => {
            lastConfigRef.current = apiData;
            setInitialRolesForm(roleConfigFormMapping(apiData));
        });
        return selected.id;
    }

    useEffect(() => {
        if (lastConfigRef.current) {
            setInitialRolesForm(roleConfigFormMapping(lastConfigRef.current));
        }
        // Labels come from t(); rebuild when locale changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale])

    useEffect(() => {
        b2bServiceObj.GetCorporateUserRoles((data) => {
            let formattedJobRoles = data.filter((jobRole) => ![Constants.USER_ROLE_SPECIALIST].includes(jobRole.id));

            formattedJobRoles = formattedJobRoles.map((jobRole) => ({
                id: jobRole.id,
                title: jobRole.name,
            }));
            /*formattedJobRoles = [
                ...formattedJobRoles,
                {
                    id: 0,
                    title: "Create New Role",
                },
            ];*/
            setJobRoles(formattedJobRoles);
        })
    },[b2bServiceObj])

    const handleChange = (key, sectionIndex, itemIndex) => {
        setInitialRolesForm((prevState) => {
            const updatedForm = {...prevState};
            const section = updatedForm[key][sectionIndex];
            const item = section.items[itemIndex];
            item.isChecked = !item.isChecked; // Toggle the checkbox state
            return updatedForm;
        });
    };

    return (
        <div className='role-wrapper-div'>
            <div className='custom-margin-div'>

                <div className='role-invite-div'>
                    <div className='config-note'>
                        <p>{t('iam.selectRoleHint')} <b>{t('iam.nonEditable')}</b>.</p>
                    </div>
                    <div className='role-dropdown'>
                        <div className='flex-end-div'>
                            <Select
                                options={jobRoles}
                                label={t('iam.selectUserRole')}
                                handleChange={handleSelectRole}
                                option={selectedRole ? selectedRole : ''}
                            />
                        </div>
                        <p className='info-note mar-15 top'>
                            {t('iam.rolesNoteIntro')} <br/> 
                            - <b>{t('iam.rolesNoteUsers')}</b> {t('iam.rolesNoteUsersRest')} <b>{t('iam.rolesNoteMembers')}</b> {t('iam.rolesNoteMembersRest')} <br/>
                            - {t('iam.rolesNoteOwnerPrefix')} <b>{t('iam.rolesNoteOwner')}</b>{t('iam.rolesNoteOwnerRest')}
                        </p>
                        
                    </div>
                </div>
                <div className='user-list-inner-div disable-pointer'>
                    {Object.keys(initialRolesForm).map((key) => (
                        <div className='roleUpdationForm' key={key}>
                            <div className='role-title-div'>
                                <span>{key}</span>
                            </div>
                            <div className='grid-container'>
                                {initialRolesForm[key].map((section, sectionIndex) => (
                                    <div key={sectionIndex} className="permissions-grid-view">
                                        <div className="section-title"><strong>{section.title}</strong></div>
                                        <div className="checkboxes-grid-view">
                                            {section.items.map((item, itemIndex) => (
                                                <div key={item.id}>
                                                    <Checkbox
                                                        checked={item.isChecked}
                                                        onChange={() => handleChange(key, sectionIndex, itemIndex)}
                                                        inputProps={{"aria-label": "controlled"}}
                                                    />
                                                    <span>{item.title}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

